import { useEffect } from "react";
import { TERMS_TEXT } from "../legal/terms";

export default function TermsModal({ onClose }) {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="terms-modal-backdrop" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="terms-modal-card" role="dialog" aria-modal="true" aria-label="Terms and Conditions">
        <div className="terms-modal-header">
          <h2>Terms &amp; Conditions</h2>
          <button type="button" className="terms-modal-close" onClick={onClose} aria-label="Close">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </button>
        </div>
        <div className="terms-modal-body">
          <pre className="terms-modal-text">{TERMS_TEXT.trim()}</pre>
        </div>
        <div className="terms-modal-footer">
          <button type="button" className="terms-modal-close-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
